import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'
import { Container } from '@uswitch/ev-core/react'
import HeroSecondary from '../../elements/hero-secondary'

import { cf2imgix } from '../../elements/imgix-img'
import Breadcrumb from '../../compounds/breadcrumb'
import Grid from '../../compounds/grid/grid-from-json.connected'

const ConnectedHeroSecondary = props => {
  const image = useEntity(props.image)

  const breadcrumbs = <Breadcrumb entity={props.breadcrumbs} />

  return (
    <HeroSecondary
      breadcrumbs={props.breadcrumbs && breadcrumbs}
      container={Container}
      image={cf2imgix(image?.file?.url)}
      imageOnMobile={props.displayImageOnMobile}
      imageOnTablet={props.displayImageOnTablet}
    >
      <Grid {...props} />
    </HeroSecondary>
  )
}

export default ConnectedHeroSecondary
